import './styles.css';

export const ActivateIcon = (_props: unknown) => {
  return <button className="activate-icon">&nbsp;&nbsp;Activate&nbsp;&nbsp;</button>;
};
